import { render } from "./DashboardView.vue?vue&type=template&id=c7a16fa6"
import script from "./DashboardView.vue?vue&type=script&lang=ts"
export * from "./DashboardView.vue?vue&type=script&lang=ts"

import "./DashboardView.vue?vue&type=style&index=0&id=c7a16fa6&lang=scss"
script.render = render

export default script